var ToasterService = /** @class */ (function () {
    function ToasterService() {
    }
    ToasterService.prototype.showErrorMessage = function (message) {
        ShowErrorPopup(message, false, undefined);
    };
    ToasterService.prototype.showSuccessMessage = function (message) {
        ShowInformationPopup(message, false, undefined, false);
    };
    ToasterService.prototype.showConfirmPopup = function (message, confirmCallback) {
        ShowConfirmPopup(message, confirmCallback);
    };
    ToasterService.prototype.showConfirmDangerPopup = function (message, confirmCallback) {
        ShowConfirmDangerPopup(message, confirmCallback);
    };
    return ToasterService;
}());
export default ToasterService;



//////////////////
// WEBPACK FOOTER
// ./app/shared/services/toaster.service.ts
// module id = 12
// module chunks = 0 1 2 3 4 5